export interface DisparityReason {
  type: DisparityReasonType;
  message: string;
  userValue: unknown;
  professionalValue: unknown;
}

export type DisparityReasonType =
  | "AGE_MISMATCH"
  | "LANGUAGE_MISMATCH"
  | "COUNTRY_MISMATCH"
  | "AGE_MISSING"
  | "LANGUAGE_MISSING"
  | "PRODUCT_CHANGED_WITH_SAME_PROFESSIONAL"
  | "PROFESSIONAL_CHANGED_WITH_SAME_PRODUCT"
  | "DISMISSED_PROFESSIONAL_SELECTED"
  | "HRC_FORM_PENDING"
  | "MC_FORM_PENDING"
  | "TEST_USER";

export const DISPARITY_LABEL_MAP: Record<
  DisparityReasonType,
  {
    user: string;
    professional: string;
  }
> = {
  AGE_MISMATCH: {
    user: "User Age",
    professional: "Allowed Age Range",
  },
  LANGUAGE_MISMATCH: {
    user: "User Languages",
    professional: "Professional Languages",
  },
  COUNTRY_MISMATCH: {
    user: "User Country",
    professional: "Allowed Countries",
  },
  AGE_MISSING: {
    user: "User Age",
    professional: "Professional Age Requirement",
  },
  LANGUAGE_MISSING: {
    user: "User Language",
    professional: "Professional Language Requirement",
  },
  PRODUCT_CHANGED_WITH_SAME_PROFESSIONAL: {
    user: "Current Product",
    professional: "Previous Product",
  },
  PROFESSIONAL_CHANGED_WITH_SAME_PRODUCT: {
    user: "Current Professional",
    professional: "Previous Professional",
  },
  DISMISSED_PROFESSIONAL_SELECTED: {
    user: "Current Professional Status",
    professional: "Past Professional Status",
  },
  HRC_FORM_PENDING: {
    user: "User Status",
    professional: "Required Action",
  },
  MC_FORM_PENDING: {
    user: "User Status",
    professional: "Required Action",
  },
  TEST_USER: {
    user: "Test User",
    professional: "Required Action",
  },
};
